import React from "react";
import { Avatar, Typography, Stack, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const FriendInteractionCard = ({ 
  rank, 
  user, 
  size = "small", 
  onClick, 
  style,
  isMobile = false,
  showRank = true // 순위 숫자 표시 여부를 제어하는 새로운 prop
}) => {
  const isLarge = size === "large";
  const isTop3 = rank <= 3;
  
  // 메달 이모지
  const getMedal = (rank) => {
    switch (rank) {
      case 1: return "🥇";
      case 2: return "🥈";
      case 3: return "🥉";
      default: return null;
    }
  };

  const theme = useTheme();
  
  // 카드 스타일
  const getCardStyle = () => {
    return {
      backgroundColor: theme.palette.background.paper,
      borderRadius: isLarge ? "12px" : "8px"
    };
  };

  // 아바타 색상
  const getAvatarColor = () => {
    return theme.palette.primary.main;
  };

  // 텍스트 색상
  const getTextColor = () => {
    return theme.palette.text.primary;
  };

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={isLarge ? 1.5 : 1}
      onClick={onClick}
      sx={{
        width: "100%",
        padding: isLarge ? (isMobile ? theme.spacing(2.5) : theme.spacing(4)) : (isMobile ? theme.spacing(1.5) : theme.spacing(2)),
        cursor: "pointer",
        position: "relative",
        minHeight: isLarge ? "auto" : (isMobile ? "120px" : "140px"),
        ...style,
        ...getCardStyle()
      }}
    >
      {/* 메달 표시 (우측 상단, 1-3위만) */}
      {isTop3 && (
        <div
          style={{
            position: "absolute",
            top: "6px",
            right: "6px",
            fontSize: isMobile ? "24px" : "32px", // 메달 크기 크게
            zIndex: 1
          }}
        >
          {getMedal(rank)}
        </div>
      )}

      {/* 순위 숫자 표시 (좌측 상단, showRank가 true일 때만) */}
      {showRank && (
        <div
          style={{
            position: "absolute",
            top: "8px",
            left: "8px",
            fontSize: isMobile ? "18px" : "22px", // 순위 글자 크기 키움
            fontWeight: "bold",
            color: getTextColor()
          }}
        >
          {rank}위
        </div>
      )}

      <Avatar 
        sx={{
          width: isLarge ? (isMobile ? 60 : 80) : (isMobile ? 32 : 40),
          height: isLarge ? (isMobile ? 60 : 80) : (isMobile ? 32 : 40),
          bgcolor: getAvatarColor(),
        }}
      >
        {user.username.substring(0, 2).toUpperCase()}
      </Avatar>
      
      <Typography 
        variant={isLarge ? (isMobile ? "h5" : "h4") : (isMobile ? "h7" : "h6")}
        sx={{
          color: getTextColor(),
          textAlign: "center",
          lineHeight: 1.2
        }}
      >
        {user.username}
      </Typography>
      
      <Typography 
        variant={isLarge ? (isMobile ? "h5" : "h4") : (isMobile ? "body2" : "body1")}
        sx={{
          fontWeight: "bold",
          color: getTextColor(),
          textAlign: "center",
          ...(isLarge && !isMobile && { fontSize: "24px" })
        }}
      >
        {user.totalInteractions || user.count || 0} interactions
      </Typography>
      
      {isLarge && user.theirCommentsCount !== undefined && user.myRepliesCount !== undefined && (
        <Typography 
          variant={isMobile ? "body1" : "h6"}
          color="text.secondary"
          sx={{ textAlign: "center" }}
        >
          {user.theirCommentsCount} comments, {user.myRepliesCount} replies
        </Typography>
      )}
    </Stack>
  );
}; 